import Load from 'components/Load';
import PrivateHostRoute from 'components/PrivateHostRoute';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const AsyncHostHome = Load(
  () => import(/* webpackChunkName: "host-homescreen" */ './pages/HostHome'),
);
const AsyncScheduleBreak = Load(
  () =>
    import(
      /* webpackChunkName: "host-homescreen" */ '../host/components/HostScheduleBreak/ScheduleBreak'
    ),
);
const AsyncGoOffline = Load(
  () =>
    import(
      /* webpackChunkName: "host-homescreen" */ '../host/components/HostStatus/GoOffline'
    ),
);
const AsyncHostStatus = Load(
  () =>
    import(
      /* webpackChunkName: "host-homescreen" */ '../host/components/HostStatus'
    ),
);
const AsyncFeedbackContainer = Load(
  () =>
    import(
      /* webpackChunkName: "host-homescreen" */ './containers/FeedbackContainer'
    ),
);

const AsyncHostPerformance = Load(
  () =>
    import(
      /* webpackChunkName: "host-homescreen" */ './components/HostPerformance/index'
    ),
);

const AsyncHostScoresAndRewards = Load(
  () =>
    import(
      /* webpackChunkName: "host-homescreen" */ './components/HostScoresAndRewards'
    ),
);

const SubRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateHostRoute
        key="host-homepage"
        path={`${path}/`}
        hideFooter
        component={AsyncHostHome}
        showBottomNavigation
        noNavbar={isCordova()}
        showSearchInNavbar={false}
      />
    </Switch>
  );
};

export const HostHomePageRoutes = (
  <Route key={'host-home'} path={`${basePath}/host/home`}>
    <>
      <SubRoutes />
    </>
  </Route>
);

export const HostHomePageWidgetRoutes = [
  <Redirect
    key={'redirect'}
    from={`${basePath}/host/dashboard`}
    to={`${basePath}/host/home`}
  />,
  <PrivateHostRoute
    key="host-break"
    path={`${basePath}/host/schedule-break/:action?`}
    hideFooter
    component={AsyncScheduleBreak}
    onTopOf={AsyncHostHome}
    showBottomNavigation
    noNavbar={isCordova()}
    showSearchInNavbar={false}
  />,
  <PrivateHostRoute
    key="host-offline-status"
    path={`${basePath}/host/status/:state?`}
    hideFooter
    component={AsyncHostStatus}
    onTopOf={AsyncHostHome}
    showBottomNavigation
    noNavbar={isCordova()}
    showSearchInNavbar={false}
  />,
  <PrivateHostRoute
    key="host-offline"
    path={`${basePath}/host/go-offline`}
    hideFooter
    component={AsyncGoOffline}
    onTopOf={AsyncHostHome}
    showBottomNavigation
    noNavbar={isCordova()}
    showSearchInNavbar={false}
  />,
  <NavigationableLayout
    key="host-feedback"
    path={`${basePath}/host/feedback`}
    hideFooter
    component={AsyncFeedbackContainer}
    showBottomNavigation
    noNavbar={isCordova()}
    nonFixedNavbar
  />,
  <NavigationableLayout
    key="host-dashboard"
    path={`${basePath}/host/performance/scores-and-rewards`}
    hideFooter
    component={AsyncHostScoresAndRewards}
    showBottomNavigation
    noNavbar={isCordova()}
    nonFixedNavbar
  />,
  <NavigationableLayout
    key="host-performance"
    path={`${basePath}/host/performance/:metric/:view?`}
    hideFooter
    component={AsyncHostPerformance}
    showBottomNavigation
    noNavbar={isCordova()}
    nonFixedNavbar
  />,
];
